<template>
  <div>
    <v-row no-gutters justify="start" align="center" class="content-header">
      <v-icon small color="accent" class="mr-2 font-weight-bold">badge</v-icon>
      <span class="font-weight-bold primary--text">Mes infos</span>
    </v-row>
    <v-form v-model="isMeFormValid" @submit.prevent.native="$canWrite && (saveMe($event))">
      <v-container class="pb-4">
        <v-row>
          <v-col cols="12" md="6" class="pa-3">
            <v-text-field
              v-model="me.firstname"
              :rules="rules.required"
              label="Prénom*"
              outlined
              hide-details
              required
            />
          </v-col>
          <v-col cols="12" md="6" class="pa-3">
            <v-text-field
              v-model="me.lastname"
              :rules="rules.required"
              label="Nom*"
              outlined
              hide-details
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="pa-3">
            <v-text-field
              v-model="me.email"
              label="Email"
              outlined
              hide-details
            />
          </v-col>
        </v-row>
      </v-container>
      <v-divider />
      <v-row no-gutters justify="end" align="center" class="pt-4">
        <v-btn
          color="primary darken-1"
          type="submit"
          class="mr-2"
          :disabled="!$canWrite || (!isMeFormValid)"
          :loading="isSavingMe"
        >
          Enregistrer
        </v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  data: () => ({
    me: {},
    rules: {
      required: [value => !!value || `Ce champ est requis`],
    },
    isSavingMe: false,
    isMeFormValid: true,
  }),
  computed: {
    ...mapState(`model/user`, {
      storeMe: state => _.cloneDeep(state.me),
    }),
  },
  watch: {
    storeMe(newValue) {
      this.me = newValue;
    },
  },
  beforeMount() {
    this.me = this.storeMe || {};
  },
  methods: {
    async saveMe() {
      this.isSavingMe = true;
      await this.$store.dispatch(`model/user/saveMe`, this.me);
      this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Informations enregistrées`,
      });
      this.isSavingMe = false;
    },
  },
};
</script>
